// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_FiscalConfigInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for PUT /payments/accounts/fiscal_config/{id}
 *
 * Updates fiscal configuration for an account.
 * All fields passed directly to provider's configureFiscalInfo().
 */
import { registerContract } from './validate'

export interface SubaccountsFranchises_FiscalConfigInput {
fiscal_config?: unknown[]
}

registerContract('SubaccountsFranchises_FiscalConfigInput', {
  fiscal_config: { type: 'array',   required: false },
})
